import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { IonicModule } from '@ionic/angular';
import { APP_ROUTES } from './app.routes';
import { RouterModule } from '@angular/router';
import { HomeDevComponent } from './home-dev/home-dev.component';
import { ApvModule } from './apv/apv.module';
import { ServicesModule } from './apv/core/services/apv.service.module';

@NgModule({
  declarations: [AppComponent, HomeDevComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(APP_ROUTES),
    IonicModule.forRoot(),
    ApvModule,
    ServicesModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
